import Vue from 'vue'
import App from './App.vue'
import { registerMicroApps, start, setDefaultMountApp } from 'qiankun'
import microApps from './micro-app'
import 'nprogress/nprogress.css'
import 'element-ui/lib/theme-chalk/index.css'
import "idempotent-babel-polyfill"
import './assets/fonts/font.css';
import {
  Button,
  Select,
  Table,
  Tooltip,
  Input,
  Option,
  TableColumn,
  Pagination,
  Scrollbar,
  Dialog,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu
} from "element-ui"

import VueUeditorWrap from "vue-ueditor-wrap"
window.commonComponent = { VueUeditorWrap }
Vue.use(Button);
Vue.use(Select);
Vue.use(Table);
Vue.use(Tooltip);
Vue.use(Input);
Vue.use(Option);
Vue.use(Pagination);
Vue.use(TableColumn);
Vue.use(Scrollbar);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);



Vue.config.productionTip = false

// 访问地址中的旧 token 替换为新 token，其他参数保持不变（需在子应用加载前执行）
function replaceUrlToken() {
  const OLD_TOKEN = 'eyJraWQiOiJFRjRGMjJDMC01Q0IwLTQzNDgtOTY3Qi0wMjY0OTVFN0VGQzgiLCJhbGciOiJFUzI1NiJ9.eyJpc3MiOiJjb20uemhpaHVpc2h1IiwiYXVkIjoiQ0FTIiwic3ViIjoi5pm65oWn5qCRIiwiaWF0IjoxNjkzMjE2OTkxLCJleHAiOjE3ODc4MjQ5OTEsImp0aSI6ImI4MjZmMTUyLWYxZTItNDQzNy04OGM2LWY0MGI3NzY3Yjk0MSIsInVpZCI6ODQ2MDcxMTY5fQ.KxQwHSVfsv5_k7cGE1rf0EV0s7J_FAZs49nBt48qUM97rTdjZnWGdblZjTPpRAa2wXQIe0cru_QTVbC40M5XqA'
  const NEW_TOKEN = 'eyJraWQiOiJFRjRGMjJDMC01Q0IwLTQzNDgtOTY3Qi0wMjY0OTVFN0VGQzgiLCJhbGciOiJFUzI1NiJ9.eyJpc3MiOiJjb20uemhpaHVpc2h1IiwiYXVkIjoia2ciLCJzdWIiOiLnjovmmI7kuq4iLCJpYXQiOjE3ODc4ODgwODgsImV4cCI6MjEwMzI0ODA4OCwianRpIjoiN2EyZjcxNTEtMGE0ZS00MmE3LWJkN2EtZjM5ZDAwYmYwMDhiIiwidWlkIjo4NDYwNzExNjl9.rFn1o6Z0Ws0JMtLM5k92dnFB6TNpa76budm208wytUE1wpLDjeXmzyVbLryad_iuqbk1RIfWFJKCHQniPeo2BA'
  const { pathname, search, hash } = window.location
  if (!search || search.indexOf(OLD_TOKEN) === -1) return
  let replaced = false
  const params = search.substring(1).split('&').map(param => {
    if (param === `token=${OLD_TOKEN}`) {
      replaced = true
      return `token=${NEW_TOKEN}`
    }
    return param
  })
  if (!replaced) return
  const newUrl = `${pathname}?${params.join('&')}${hash}`
  if (window.history && window.history.replaceState) {
    window.history.replaceState(window.history.state, '', newUrl)
  } else {
    window.location.replace(newUrl)
  }
}
replaceUrlToken()

const instance = new Vue({
  render: h => h(App)
}).$mount('#app')

// 定义loader方法，loading改变时，将变量赋值给App.vue的data中的isLoading
function loader(loading) {
  if (instance && instance.$children) {
    // instance.$children[0] 是App.vue，此时直接改动App.vue的isLoading
    instance.$children[0].isLoading = loading
  }
}

// 给子应用配置加上loader方法
const apps = microApps.map(item => {
  console.log(item,'itemitemitem')
  return {
    ...item,
    loader
  }
})

registerMicroApps(apps, {
  beforeLoad: app => {
    console.log('before load app.name====>>>>>', app.name)
  },
  beforeMount: [
    app => {
      console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name)
    }
  ],
  afterMount: [
    app => {
      // fix:qiankun应用无法使用vue-devtool的问题
      if (window.__QIANKUN_SUB_APP_VM__ && process.env.NODE_ENV === 'development') {
        instance.$children.push(window.__QIANKUN_SUB_APP_VM__)
      }
      console.log('[LifeCycle] after mount %c%s', 'color: green;', app.name)
    }
  ],
  afterUnmount: [
    app => {
      console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name)
    }
  ]
})
setDefaultMountApp('/knowledgeMap')

start({
  prefetch: true,
  sandbox: false,
  excludeAssetFilter: (url) => {
    const whileList = [];
    const whileword = ["base1.zhihuishu.com","base2.zhihuishu.com", "assets.zhihuishu.com", "lc.zhihuishu.com","www.zhihuishu.com"];
    if (whileList.includes(url)) {
      return true;
    }
    return whileword.some((w) => {
      return url.includes(w);
    });
  }
})
